// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Sunday`
};

const el_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Κυριακή`
};

const ru_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Воскресенье`
};

const he_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `יום ראשון`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sunday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sunday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sunday", locale)
	if (locale === "en") return en_sunday(inputs)
	if (locale === "el") return el_sunday(inputs)
	if (locale === "ru") return ru_sunday(inputs)
	if (locale === "he") return he_sunday(inputs)
	return "sunday"
};